module.exports = __webpack_public_path__ + "static/img/product_images_18_h5_zh.21a0314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_18_h5_zh.png
// module id = Sp32
// module chunks = 34